export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6800.57f51c41.jpg";